import React from 'react';
import { motion } from 'framer-motion';
interface SlideLayoutProps {
  children: React.ReactNode;
  centered?: boolean;
  className?: string;
}
export function SlideLayout({
  children,
  centered = false,
  className = ''
}: SlideLayoutProps) {
  const outerClasses = ['absolute inset-0 w-full h-full', 'bg-gradient-to-br from-white to-slate-50', 'overflow-y-auto', 'pb-24 sm:pb-28', centered ? 'flex flex-col items-center justify-center px-5 sm:px-8 md:px-10 pt-6 sm:pt-8' : 'pt-10 sm:pt-14 md:pt-16 px-5 sm:px-8 md:px-12 lg:px-24', className].join(' ');
  const innerClasses = ['max-w-6xl mx-auto w-full', centered ? 'text-center' : ''].join(' ');
  return <motion.div className={outerClasses} data-id="element-363">
      <div className={innerClasses} data-id="element-364">{children}</div>
    </motion.div>;
}